import { objectToUrlParams } from 'utils/params';
import BaseResource from './BaseResource';

export default class DocumentResource extends BaseResource {
  constructor() {
    super({ url: '/api/artwork' });
  }

  save(data, params = {}) {
    const urlParams = objectToUrlParams(params);
    return super
      .post(data, { url: `${this.url}/documents${urlParams ? urlParams : ''}` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  export(id) {
    return super
      .post({}, { url: `${this.url}/documents/${id}/export` })
      .then((response) => response)
      .catch((error) => error.response);
  }

  refresh(id) {
    return super
      .put({}, { url: `${this.url}/documents/${id}/refresh` })
      .then((response) => response)
      .catch((error) => error.response);
  }
}
